import { Grid, type SxProps, type Theme } from '@mui/material';
import { ODSToggleChip, type ODSToggleChipProps } from '@telekom-ods/react-ui-kit';
import type { ReactNode } from 'react';

interface ChipProps {
  label: string;
  selected?: boolean;
  disabled?: boolean;
  onSelect?: (value: boolean) => void;
  onDeselect?: (value: boolean) => void;
  icon?: ReactNode;
  pictureProps?: ODSToggleChipProps['pictureProps'];
  defaultSelected?: boolean;
  transparentBg?: boolean;
  sx?: SxProps<Theme>;
}

const Chip: React.FC<ChipProps> = ({
  label,
  selected = false,
  disabled = false,
  onSelect = null,
  onDeselect = null,
  icon,
  pictureProps = null,
  defaultSelected = false,
  transparentBg = true,
  sx = {},
}) => {
  const handleSelect = () => {
    onSelect?.(true);
  };

  const handleDeselect = () => {
    onDeselect?.(false);
  };

  return (
    <Grid sx={{ display: 'inline-flex', padding: '0 0.25rem', ...(sx && { sx }) }}>
      <ODSToggleChip
        label={label}
        selected={selected}
        disabled={disabled}
        onSelectedChange={selected ? handleDeselect : handleSelect}
        {...(pictureProps && { pictureProps })}
        {...(icon && { icon })}
        defaultSelected={defaultSelected}
        transparentBg={transparentBg}
      />
    </Grid>
  );
};

export default Chip;
